'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense, type PropsWithChildren } from 'react';
import { ErrorBoundary } from 'next/dist/client/components/error-boundary';
import dynamic from 'next/dynamic';
import { ErrorComponent } from './ErrorComponent';
import { LoadingComponent } from './LoadingComponent';
import type { MermaidConfig } from 'mermaid';
import { useDarkMode } from '@/client/hooks/useDarkMode';
export interface MermaidProps {
  name?: string;
  config?: MermaidConfig;
}
const MermaidInner = dynamic(() => import('./MermaidInner'), {
  loading: LoadingComponent
});
export default function Mermaid(t0) {
  const $ = _c(8);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const isDarkMode = useDarkMode();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>Loading...{" "}<span className="appear-10s">do you have Javascript enabled?</span></div>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isDarkMode ? 1 : 0;
  let t3;
  if ($[4] !== children || $[5] !== props || $[6] !== t2) {
    t3 = <ErrorBoundary errorComponent={ErrorComponent}><Suspense fallback={t1}><MermaidInner key={t2} {...props}>{children}</MermaidInner></Suspense></ErrorBoundary>;
    $[4] = children;
    $[5] = props;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}